<template>
  <v-menu offset-y :close-on-content-click="false" ref="menu" v-if="allowedTests.length" @input="onMenuToggle">
    <template v-slot:activator="{ on, attrs }">
      <v-btn elevation="0" class="font-xs" v-bind="attrs" v-on="on">
        Отправить тест
        <v-icon v-if="attrs['aria-expanded']">mdi-chevron-down</v-icon>
        <v-icon v-else>mdi-chevron-up</v-icon>
      </v-btn>
    </template>
    <ListTests v-model="selectedTests" :loading="loading" :balances="balances">
      <v-btn color="primary" class="mx-auto w-100 btn-disabled-primary"
           :disabled="!selectedTests.length || loading" :loading="loading" small @click.stop="send"
        >
          Отправить
        </v-btn>
    </ListTests>
    <!-- <v-list :disabled="loading" >
      <v-list :disabled="loading" class="menu-send-test">
        <v-list-item ripple @click="setSelectedTests('ALL')">
          <v-list-item-action class="mr-4">
            <v-icon class="icon-sm" :color="selectedTests.length < allowedTests.length ? '' : 'primary'">{{ iconSelectedTests }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-sm">Все {{selectedTests}}  </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="test in allowedTests" :key="test.id" @click="setSelectedTests(test)">
          <v-list-item-action class="mr-4">
            <v-icon class="icon-sm" :color="isTestSelected(test) ? 'primary' : ''">
              {{isTestSelected(test) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-sm">
              {{ test.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="d-flex px-4 py-2">
        <v-btn color="primary" class="mx-auto w-100 btn-disabled-primary"
           :disabled="!selectedTests.length || loading" :loading="loading" small @click.stop="send"
        >
          Отправить
        </v-btn>
      </div>
    </v-list> -->
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import ListTests from './ListTests.vue';

export default {
  name: 'CreateTestingSessionButton',
  components: {
    ListTests
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    sendTests: {
      type: Function,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // (candidateId) → Promise<{ код теста: остаток } | null>; без него меню остаётся прежним
    loadBalances: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    selectedTests: [],
    balances: null,
    balancesRequest: 0,
  }),
  computed: {
    ...mapGetters({
      stdTests: 'tests/allowedTests',
      allInstrumentSets: 'testEditor/instrumentSets'
    }),
    // allTestsSelected() {
    //   return this.selectedTests.length === this.allowedTests.length;
    // },
    // notAllTestsSelected() {
    //   return this.selectedTests.length > 0 && !this.allTestsSelected;
    // },
    // iconSelectedTests() {
    //   if (this.allTestsSelected) return 'mdi-checkbox-marked';
    //   if (this.notAllTestsSelected) return 'mdi-close-box';
    //   return 'mdi-checkbox-blank-outline';
    // },
    instrumentSets() {
      return this.allInstrumentSets
        .filter(el => el.status === 'published')
        .filter(el => this.$store.getters['tests/isTestCodeAllowed'](el.code))
        .map(el => ({
          title: el.name,
          id: el.code,
          isStd: false,
      }));
    },
    allowedTests() {
      return [
        ...this.stdTests,
        ...this.instrumentSets
      ];
    }

  },
  methods: {
    // Остатки отправителя подгружаем при открытии меню: пока не пришли (или не удалось) — все тесты доступны
    async onMenuToggle(opened) {
      if (!opened || !this.loadBalances) return;
      this.balances = null;
      this.balancesRequest += 1;
      const request = this.balancesRequest;
      const balances = await this.loadBalances(this.data.id).catch(() => null);
      // Меню переоткрыли, пока шёл запрос, — ответ устарел
      if (request !== this.balancesRequest) return;
      this.balances = balances;
      // Недоступные тесты из выбора убираем
      if (balances) this.selectedTests = this.selectedTests.filter((code) => !(code in balances) || balances[code] > 0);
    },
    // ...mapActions({
    //   loadInstrumentSets: 'testEditor/loadInstrumentSets'
    // }),
    // isTestSelected(test) {
    //   return this.selectedTests.some((t) => t.id === test.id);
    // },
    // setSelectedTests(val) {
    //   if (val === 'ALL') {
    //     if (this.selectedTests.length) {
    //       this.selectedTests = [];
    //     } else {
    //       this.selectedTests = this.allowedTests;
    //     }
    //     return;
    //   }
    //   if (this.selectedTests.some((t) => t === val)) {
    //     this.selectedTests = this.selectedTests.filter((t) => t !== val);
    //   } else {
    //     this.selectedTests.push(val);
    //   }
    // },

    send() {
      const data = {
        // tests: this.selectedTests.map(el => el.id),
        tests: this.selectedTests,
        candidate: this.data.id,
      };
      this.sendTests(data).then(() => {
        this.selectedTests = [];
        this.$refs.menu.isActive = false;
        // this.$toast.success('Тест отправлен', '', { position: 'topRight' });
      }).catch(() => {
        // Не отправлено (сообщение уже показано) — меню и выбор тестов оставляем
      });
    },
  },
};
</script>

<style >
.menu-send-test {
  max-height: 350px;
  overflow-y: auto;
}
</style>
